import { render, staticRenderFns } from "./BankDetailsForms.vue?vue&type=template&id=4ab4a4c5"
import script from "./BankDetailsForms.vue?vue&type=script&lang=js"
export * from "./BankDetailsForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports